<template>
  <div class="container">
    <div style="margin-bottom: 12px">
      <el-button
        class="mwow-button-filled primary"
        @click="handleExport"
        v-debounce="1000"
        >导出明细</el-button
      >
      <create-settlement-dialog @change="toStoreTab">
        <el-button class="mwow-button-filled inter" style="margin-left: 12px"
          >快速结算工资</el-button
        >
      </create-settlement-dialog>
    </div>
    <common-search-form-wrapper :hiddenExpand="true" :reset="handleSet">
      <el-form size="mini" :model="searchInfo" label-width="70px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="教师姓名:" prop="name">
              <el-input
                v-model="searchInfo.name"
                placeholder="请输入"
                @change="handleSearch"
                clearable
                prefix-icon="el-icon-search"
                maxlength="120"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课时间:" prop="lesson_date">
              <common-date-range-selector
                v-model="searchInfo.lesson_date"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                @change="handleLessonDateChange"
                value-format="yyyy-MM-dd"
                :clearable="false"
              >
              </common-date-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <div class="range-selector-wrap">
                <div
                  :class="`button ${
                    currentTimeType === 'current_week' ? 'active' : ''
                  }`"
                  @click="searchRangeChange('current_week')"
                  v-debounce="1000"
                >
                  本周
                </div>
                <div
                  :class="`button ${
                    currentTimeType === 'prev_week' ? 'active' : ''
                  }`"
                  @click="searchRangeChange('prev_week')"
                  v-debounce="1000"
                >
                  上周
                </div>
                <div
                  :class="`button ${
                    currentTimeType === 'current_month' ? 'active' : ''
                  }`"
                  @click="searchRangeChange('current_month')"
                  v-debounce="1000"
                >
                  本月
                </div>
                <div
                  :class="`button ${
                    currentTimeType === 'prev_month' ? 'active' : ''
                  }`"
                  @click="searchRangeChange('prev_month')"
                  v-debounce="1000"
                >
                  上月
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <el-table
      size="mini"
      v-horizontal-scroll
      :data="tableData"
      stripe
      ref="mainTable"
      style="width: 100%"
      tooltip-effect="dark"
    >
      <el-table-column label="教师姓名" prop="teacher.name"></el-table-column>
      <el-table-column label="教师统计" align="center">
        <el-table-column label="点名课次" prop="lesson_count">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toRollcallLesson(scope.row)"
              >{{ scope.row.lesson_count }}</span
            >
          </template>
        </el-table-column>
        <el-table-column label="排课课时" prop="lesson_consume_number">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toRollcallLesson(scope.row)"
            >
              {{ scope.row.lesson_consume_number }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="1vN课次" prop="lesson_one_to_many_count">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toRollcallLesson(scope.row, 1)"
            >
              {{ scope.row.lesson_one_to_many_count }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="1v1课次" prop="lesson_one_to_one_count">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toRollcallLesson(scope.row, 2)"
            >
              {{ scope.row.lesson_one_to_one_count }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
      <el-table-column label="学员统计" align="center">
        <el-table-column prop="student_count">
          <template slot="header">
            <span>点名学员</span>
            <el-popover
              placement="top"
              popper-class="followuppopover"
              trigger="hover"
              width="150"
            >
              <p>根据已点名签到的课次学员人数，自动去重计算</p>
              <i
                class="el-icon-question"
                slot="reference"
                style="
                  margin: 0 0 0 8px;
                  color: #bebfc0;
                  font-size: 16px;
                  vertical-align: text-bottom;
                "
              ></i>
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column
          label="耗课数"
          prop="student_real_consume_number"
        ></el-table-column>
        <el-table-column label="课消金额" prop="student_consume_amount">
          <template slot-scope="scope"
            >￥{{ scope.row.student_consume_amount }}</template
          >
        </el-table-column>
      </el-table-column>
      <el-table-column label="学员点名人次统计" align="center">
        <el-table-column label="到课（含迟到）" prop="student_status_attend">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toRollcallStudent(scope.row, [1, 2])"
            >
              {{ scope.row.student_status_attend }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="请假" prop="student_status_leave">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toRollcallStudent(scope.row, [3])"
            >
              {{ scope.row.student_status_leave }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="未到课" prop="student_status_absent">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toRollcallStudent(scope.row, [4])"
            >
              {{ scope.row.student_status_absent }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="体验" prop="student_type_experience">
          <template slot-scope="scope">
            <span
              class="mwow-green pointer"
              @click="toExperienceList(scope.row)"
            >
              {{ scope.row.student_type_experience }}
            </span>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="page"
      :page-size="pageSize"
      :page-sizes="pageSizeArray"
      :style="{ float: 'right', padding: '20px' }"
      :total="total"
      @current-change="handlePagerChange"
      @size-change="handlePagerSizeChange"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>
  </div>
</template>
<script>
import {
  dateFormat,
  getCurrentMonth,
  getCurrentWeek,
} from "@/utils/timeFormat";
import createSettlementDialog from "../tabStore/createSettlementDialog.vue";
import { exportLoop } from "@/utils/export";
import {
  getSalaryTeacherStatisticsApi,
  exportSalaryTeacherStatisticsApi,
} from "@/api/salary";
import eventBus from "@/utils/bus";
import commonDateRangeSelector from "@/components/commonDateRangeSelector.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";
export default {
  props: ["visible"],
  components: {
    createSettlementDialog,
    commonDateRangeSelector,
    commonSearchFormWrapper,
  },
  data() {
    return {
      searchInfo: {
        lesson_date: [],
      },
      currentTimeType: "current_month",
      tableData: [],
      page: 1,
      pageSize: 10,
      pageSizeArray: [10],
      total: 0,
    };
  },
  created() {
    // 单次watch页面展示，然后加载数据
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.searchRangeChange(this.currentTimeType);
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.searchRangeChange(this.currentTimeType);
    }
  },
  methods: {
    toStoreTab() {
      eventBus.$emit("quickly-create-salary-settlement");
    },
    handleExport() {
      const option = {
        lesson_start_date: "",
        lesson_end_date: "",
      };
      if (this.searchInfo.name) {
        option.name = this.searchInfo.name;
      }
      if (
        this.searchInfo.lesson_date &&
        this.searchInfo.lesson_date.length === 2
      ) {
        option.lesson_start_date = this.searchInfo.lesson_date[0];
        option.lesson_end_date = this.searchInfo.lesson_date[1];
      } else {
        this.$message({
          type: "warning",
          message: "请先选择时间",
        });
        return false;
      }
      exportSalaryTeacherStatisticsApi(option).then((res) => {
        exportLoop(res.data.task_id);
      });
    },
    handleLessonDateChange() {
      this.currentTimeType = "";
      this.handleSearch();
    },
    searchRangeChange(type) {
      let start = "";
      let end = "";
      const now = new Date();
      this.currentTimeType = type;
      switch (type) {
        case "current_week":
          const cw = getCurrentWeek(now);
          start = dateFormat("YYYY-mm-dd", cw[0]);
          end = dateFormat("YYYY-mm-dd", now);
          break;
        case "prev_week":
          const pw = getCurrentWeek(now.getTime() - 7 * 24 * 60 * 60 * 1000);
          start = dateFormat("YYYY-mm-dd", pw[0]);
          end = dateFormat("YYYY-mm-dd", pw[1]);
          break;
        case "current_month":
          const cm = getCurrentMonth(now);
          start = dateFormat("YYYY-mm-dd", cm[0]);
          end = dateFormat("YYYY-mm-dd", now);
          break;
        case "prev_month":
          const d = now.getDate();
          const pm = getCurrentMonth(now.getTime() - d * 24 * 60 * 60 * 1000);
          start = dateFormat("YYYY-mm-dd", pm[0]);
          end = dateFormat("YYYY-mm-dd", pm[1]);
          break;
      }
      this.searchInfo.lesson_date = [start, end];
      this.handleSearch();
    },
    getList(params) {
      const option = {
        page: params.page,
        page_size: params.page_size,
      };
      if (this.searchInfo.name) {
        option.name = this.searchInfo.name;
      }
      if (
        this.searchInfo.lesson_date &&
        this.searchInfo.lesson_date.length === 2
      ) {
        option.lesson_start_date = this.searchInfo.lesson_date[0];
        option.lesson_end_date = this.searchInfo.lesson_date[1];
      } else {
        this.$message({
          type: "warning",
          message: "请先选择上课时间",
        });
        return false;
      }
      getSalaryTeacherStatisticsApi(option).then((res) => {
        if (res.error_code === 0) {
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.page = res.data.page;
        }
      });
    },
    handleSearch() {
      this.getList({
        page: 1,
        page_size: this.pageSize,
      });
    },
    handleSet() {
      this.searchInfo = {
        name: "",
        lesson_date: [],
      };
      this.handleSearch();
    },
    handlePagerChange(e) {
      this.getList({
        page: e,
        page_size: this.pageSize,
      });
    },
    handlePagerSizeChange(e) {
      this.pageSize = e;
      this.getList({
        page: 1,
        page_size: e,
      });
    },
    toRollcallLesson(common, course_type) {
      const params = {
        teacher_id: common.teacher.teacher_id,
        teacher_name: common.teacher.name,
        lesson_date: this.searchInfo.lesson_date,
      };
      if (course_type) {
        params.course_type = course_type;
      }
      sessionStorage.setItem(
        "salary-achievements-link-to-rollcall-list",
        JSON.stringify(params)
      );
      const url = `${window.location.origin}/#/layout/teaching/roll_call?tab=rollCallRecord`;
      window.open(encodeURI(url), "_blank");
    },
    toRollcallStudent(common, student_status_list) {
      const params = {
        teacher_id: common.teacher.teacher_id,
        teacher_name: common.teacher.name,
        lesson_date: this.searchInfo.lesson_date,
        student_status_list: student_status_list,
      };
      sessionStorage.setItem(
        "salary-achievements-link-to-rollcall-student-list",
        JSON.stringify(params)
      );
      const url = `${window.location.origin}/#/layout/teaching/roll_call?tab=rollCallStudentList`;
      window.open(encodeURI(url), "_blank");
    },
    toExperienceList(data) {
      const params = {
        teacher_id: data.teacher.teacher_id,
        teacher_name: data.teacher.name,
        lesson_date: this.searchInfo.lesson_date,
        experience_statu: 2,
      };
      sessionStorage.setItem(
        "salary-achievements-link-to-experience-student-list",
        JSON.stringify(params)
      );
      setTimeout(() => {
        const url = `${window.location.origin}/#/layout/recruit/experience?from=salary_tab_achievements`;
        window.open(encodeURI(url), "_blank");
      }, 500);
    },
  },
};
</script>
<style lang="scss" scoped>
.range-selector-wrap {
  .button {
    line-height: 28px;
    padding: 0 11px;
    font-size: 12px;
    border: 1px solid #e7e8ea;
    border-radius: 4px;
    color: #5c5d5e;
    display: inline-block;
    margin-right: 12px;
    cursor: pointer;
    &.active {
      color: #07d1aa;
      border-color: #07d1aa;
      background-color: #f0fdfa;
    }
  }
}
.pointer {
  cursor: pointer;
}
</style>
